
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"-296.6 263 36 36","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M-276.5 292.7l2.5-.1c.4 0 .8-.2 1.1-.5s.4-.7.4-1.1l-1.2-21.8 7.9 2.4c.1 0 .2.1.3.1.3.2.5.4.6.7.1.3.1.6 0 .9l-5.9 19.8c-.1.3-.3.6-.7.8-.3.2-.7.2-1 .1l-4-1.3zM-286.3 282.3c.2.2.5.3.7.4.3.1.6.1.9.1.3 0 .6-.1.8-.2.3-.1.5-.3.7-.5l.1-.1h.1c.1 0 .1 0 .2.1.4.4 1 .6 1.6.5.6 0 1.1-.3 1.5-.7.4-.4.6-1 .6-1.6 0-.6-.3-1.1-.7-1.5l-3.5-3.1-3.1 3.5c-.2.2-.3.5-.4.7-.1.3-.1.6-.1.9 0 .3.1.6.2.8 0 .3.1.5.4.7zM-283.6 285c.4-.1.8-.1 1.2 0l-.7-1.3-.5 1.3zM-289.4 271l-.4 1.6h.9l-.5-1.6z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M-291.3 290.8c0 .2.1.4.1.5.1.2.2.3.3.4.1.1.3.2.5.3.2.1.3.1.5.1l2.4-.1 12.2-.6c.4 0 .7-.2.9-.4.2-.3.4-.6.3-1l-1.1-20.6c0-.3-.1-.6-.3-.8-.2-.2-.5-.4-.8-.4h-.3l-14.7.8c-.4 0-.7.2-.9.4s-.4.6-.3 1l1.2 20.4zm3.8-12l3.8-4.3s.1 0 .1-.1h.2s.1 0 .1.1l4.3 3.8c.6.5.9 1.2 1 1.9.1.7-.1 1.5-.5 2.1-.4.6-1 1.1-1.7 1.3-.7.2-1.5.2-2.2-.1l.8 1.8v.2c0 .1 0 .1-.1.1l-.1.1h-.2c-.7-.2-1.4-.2-2 .1h-.2c-.1 0-.1 0-.1-.1l-.1-.1v-.2l.7-1.8c-.4.3-.9.4-1.4.4h-.7c-.5-.1-1.1-.3-1.5-.7-.4-.4-.7-.8-.9-1.4-.2-.5-.2-1.1-.1-1.6.2-.6.5-1.1.8-1.5zm-3.2-5l.8-3.3c0-.2.2-.2.4-.3.2 0 .4.1.5.2l1.2 3.2v.1c0 .2-.2.3-.4.3-.1 0-.2 0-.2-.1l-.2-.7-1.2.1-.2.7c0 .1-.1.1-.2.1-.3 0-.5-.1-.5-.3z"}})])
          )
        }
      }
    